import { render, staticRenderFns } from "./NursingStaff.vue?vue&type=template&id=5649013d&scoped=true"
import script from "./NursingStaff.vue?vue&type=script&lang=js"
export * from "./NursingStaff.vue?vue&type=script&lang=js"
import style0 from "./NursingStaff.vue?vue&type=style&index=0&id=5649013d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5649013d",
  null
  
)

export default component.exports